<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>fact_check</md-icon>
                    </div>
                    <h4 class="title">工具元件</h4>
                </md-card-header>
                <md-card-content>
                    <v-data-table :headers="headers" :items="queriedData" :items-per-page="5" :sort-desc="[false, true]" hide-default-footer class="paginated-table table-striped table-hover">
                        <template v-slot:top>
                            <v-row justify="space-between">
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-text-field v-model="searchQuery" label="查找" type="queryParams.name" class="mb-3" clearable style="width: 200px"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.course="{ item }">{{ courseMap[item.course] }}</template>
                        <template v-slot:item.project="{ item }">{{ projectMap[item.project] }}</template>
                        <template v-slot:item.tool_type="{ item }">{{ toolTypeMap[item.tool_type] }}</template>
                        <template v-slot:item.option="{ item }">
                            <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)" style="padding-right: 30px;">
                                <md-icon>edit</md-icon>
                            </md-button>
                            <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(item)">
                                <md-icon>close</md-icon>
                            </md-button>
                        </template>
                    </v-data-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
                    </div>
                    <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"> </pagination>
                    <md-button class="md-success md-sm" @click="toNewTool">新增</md-button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>
<script>
import { Pagination } from '@/components'
import { listUtilComponent, removeUtilComponent } from '@/api/component/util_component'
import { listCourse } from '@/api/course'
import { listProject } from '@/api/project'
import { arrToObj } from '@/utils/util'
import Swal from 'sweetalert2'
export default {
    components: {
        Pagination
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.tableData
            if (this.searchedData.length > 0) {
                result = this.searchedData
            }
            return result.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length
        }
    },
    data() {
        return {
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            propsToSearch: ['_name'],
            searchedData: [],
            fuseSearch: null,
            tableData: [],
            courseMap: {},
            projectMap: {},
            queryParams: {},
            headers: [
                { text: '课程', align: 'center', value: 'course' },
                { text: '项目', align: 'center', value: 'project' },
                { text: '工具元件', align: 'center', value: 'name' },
                { text: '工具类型', align: 'center', value: 'tool_type' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            toolTypeMap: {
                xzjg: '旋转紧固类',
                fzqj: '辅助敲击类',
                zkqx: '钻孔切削类',
                ybcl: '仪表测量类',
                dmpg: '打磨抛光类',
                hjnt: '焊接粘接类',
                jyl: '绝缘类',
                zygj: '专用工具',
            }
        }
    },
    methods: {
        async init() {
            const courseResult = await listCourse({ getAll: true })
            this.courseMap = arrToObj(courseResult.data.rows, '_id', 'name')
            console.log(this.courseMap)
            const projectResult = await listProject({ getAll: true })
            this.projectMap = arrToObj(projectResult.data.rows, '_id', 'name')
            this.getList()
        },
        getCourseList() {
            listCourse({ getAll: true }).then((res) => {
                this.courseList = res.data.rows
            })
        },
        getList() {
            let query = Object.assign(this.queryParams, this.pagination)
            listUtilComponent(query).then((res) => {
                this.tableData = res.data.rows
                this.pagination.total = res.data.total
            })
        },
        toNewTool() {
            this.$router.push({ path: './NewToolMeta' })
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                if (this.currentSortOrder === '_name') {
                    return a[sortBy].localeCompare(b[sortBy])
                }
                return b[sortBy].localeCompare(a[sortBy])
            })
        },
        handleEdit(item) {
            this.$router.push({ path: './NewToolMeta', query: item })
        },
        async handleDelete(item) {
            let result = await Swal.fire({
                title: '删除信息',
                text: `${item.name} 被删除后将无法恢复，请确认！`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                buttonsStyling: false
            })

            if (result.value) {
                const delResult = await removeUtilComponent(item)
                if (delResult.code == 200) {
                    this.$notify({
                        timeout: 1500,
                        message: '删除成功',
                        icon: 'add_alert',
                        horizontalAlign: 'center',
                        verticalAlign: 'bottom',
                        type: 'success'
                    })
                    this.getList()
                }
            }
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        'queryParams.name'() {
            this.getList()
        },
        'pagination.currentPage'() {
            this.getList()
        },
        'pagination.perPage'() {
            this.getList()
        }
    }
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
</style>